/**
 * @fileoverview Protected route components for authentication and RBAC
 */
import { Navigate } from 'react-router-dom';
import { useAuth, checkIsAdmin } from '@/contexts/AuthContext';

/** Requires any authenticated user */
export const ProtectedRoute = ({ children }) => {
    const { isAuthenticated } = useAuth();
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }
    return <>{children}</>;
};

/** Requires certifier or superadmin role — redirects students/recipients to /settings */
export const AdminRoute = ({ children }) => {
    const { isAuthenticated, user } = useAuth();
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }
    const isAdmin = checkIsAdmin(user);
    if (!isAdmin) {
        return <Navigate to="/settings" replace />;
    }
    return <>{children}</>;
};
